var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3957 22.5208C18.479 22.7916 17.3957 22.9166 16.1248 22.9166H9.87484C8.604 22.9166 7.52067 22.7916 6.604 22.5208C6.83317 19.8124 9.61442 17.677 12.9998 17.677C16.3853 17.677 19.1665 19.8124 19.3957 22.5208Z",
    stroke: "#558AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1252 2.08325H9.87516C4.66683 2.08325 2.5835 4.16659 2.5835 9.37492V15.6249C2.5835 19.5624 3.771 21.7187 6.60433 22.5208C6.8335 19.8124 9.61475 17.677 13.0002 17.677C16.3856 17.677 19.1668 19.8124 19.396 22.5208C22.2293 21.7187 23.4168 19.5624 23.4168 15.6249V9.37492C23.4168 4.16659 21.3335 2.08325 16.1252 2.08325ZM13.0002 14.7603C10.9377 14.7603 9.271 13.0833 9.271 11.0208C9.271 8.95825 10.9377 7.29159 13.0002 7.29159C15.0627 7.29159 16.7293 8.95825 16.7293 11.0208C16.7293 13.0833 15.0627 14.7603 13.0002 14.7603Z",
    stroke: "#558AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7293 11.0209C16.7293 13.0834 15.0627 14.7605 13.0002 14.7605C10.9377 14.7605 9.271 13.0834 9.271 11.0209C9.271 8.95841 10.9377 7.29175 13.0002 7.29175C15.0627 7.29175 16.7293 8.95841 16.7293 11.0209Z",
    stroke: "#558AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.7b371808af504767d65e2de2d61101db.svg";
export { ForwardRef as ReactComponent };